var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"loading-logo",attrs:{"src":require("@/assets/loading.png"),"alt":"logo"}}),_c('span',{staticClass:"loading-beam"})]),_c('div',{staticClass:"loading-text-wrapper"},[_c('span',{staticClass:"loading-text"}),_c('span',{staticClass:"loading-beam"})])])
}]

export { render, staticRenderFns }